/* eslint-disable @typescript-eslint/tslint/config */
import { dependencies } from '../../class/workflow.dependency';
import { LogicFnRef } from '../../class/workflow.type';
import { LogicFnContext } from '../../service/logic/logic.service';

declare type Desc = LogicFnRef | LogicFnRef[];

/** Helper class for title strings  */
export class CustomTextHelper {
  /**
   * Custom title
   */
  private static customText(titleFn: Desc, context: LogicFnContext, iterationId?: number, pageIterationId?: number): string {
    const result = dependencies.logicService.evaluate(titleFn, context, 'single', iterationId, pageIterationId);
    return result && result[0];
  }

  /**
   * Returns translated text based on config value with or without custom text function
   * @param customTextFn config logic fn to translate text for title, label, tooltip etc...
   * @param context page, card or field
   * @param defaultValue parsable default value without using custom fn
   * @param iterationId field card iteration
   * @param pageIterationId page iteration
   */
  public static customTextOrDefault(
    customTextFn: Desc,
    context: LogicFnContext,
    defaultValue: string,
    iterationId?: number,
    pageIterationId?: number
  ): string {
    const customText = CustomTextHelper.customText(customTextFn, context, iterationId, pageIterationId);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return !!customText ? customText : <string>dependencies.stringVariableService.parse(defaultValue, iterationId, pageIterationId);
  }
}
